import dayjs from "lib/dayjs";

export function formatRelativeTime(dateInput: string | Date, timeZone: string): string {
    const date = typeof dateInput === "string" ? dayjs(dateInput).toDate() : dateInput;
    const now = dayjs();

    // Whole (truncated) minutes / hours / days / years, as date-fns counted them.
    const minutesDiff = now.diff(date, "minute");
    if (minutesDiff < 1) return "just now";
    if (minutesDiff < 60) return `${minutesDiff} minute${minutesDiff !== 1 ? "s" : ""} ago`;

    const hoursDiff = now.diff(date, "hour");
    if (hoursDiff < 24) return `${hoursDiff} hour${hoursDiff !== 1 ? "s" : ""} ago`;

    const daysDiff = now.diff(date, "day");
    if (daysDiff < 7) return `${daysDiff} day${daysDiff !== 1 ? "s" : ""} ago`;

    const isThisYear = now.diff(date, "year") === 0;
    const options: Intl.DateTimeFormatOptions = {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone,
    };
    if (!isThisYear) {
        options.year = "numeric";
    }
    return new Intl.DateTimeFormat("en-US", options).format(date);
}

export function formatFullTimestamp(dateInput: string | Date, timeZone: string): string {
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

    return new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZoneName: "short",
        timeZone,
    }).format(date);
}
